const FilterButton = ({
  name,
  onClick,
  selectedOptions,
  disabled = false,
  subLabel = '',
}: {
  name: string;
  onClick: () => void;
  disabled?: boolean;
  selectedOptions?: string;
  subLabel?: string;
}) => {
  return (
    <button
      className={`filter-button ${selectedOptions && 'filter-button--active'}`}
      disabled={disabled}
      onClick={onClick}
      type="button"
    >
      <span className="ch-width--12">
        {name}
        {subLabel && <span className="ch-fw--400"> {subLabel}</span>}
      </span>
      {selectedOptions && (
        <small className="ch-color--ac-blue ch-text--ellipsis">
          {selectedOptions}
        </small>
      )}
    </button>
  );
};

export default FilterButton;
